/** Maps tenant branding into CSS variables for headers, nav, and primary buttons. */

function hexToRgbTriplet(hex) {
  if (!hex || typeof hex !== 'string') return null;
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
  if (!m) return null;
  return `${parseInt(m[1], 16)}, ${parseInt(m[2], 16)}, ${parseInt(m[3], 16)}`;
}

/**
 * @param {object} branding - subset of tenant settings (primaryColor, secondaryColor, accentColor, neutralColor)
 */
export function applyTenantBrandingCssVars(branding) {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  const primary = (branding && branding.primaryColor) || '#3B82F6';
  const secondary = (branding && branding.secondaryColor) || '#0F172A';
  const accent = (branding && branding.accentColor) || primary;
  const neutral = (branding && branding.neutralColor) || secondary;
  const rgbPrimary = hexToRgbTriplet(primary) || '59, 130, 246';
  const rgbAccent = hexToRgbTriplet(accent) || rgbPrimary;
  root.style.setProperty('--tenant-color-primary', primary);
  root.style.setProperty('--tenant-color-secondary', secondary);
  root.style.setProperty('--tenant-color-accent', accent);
  root.style.setProperty('--tenant-color-neutral', neutral);
  root.style.setProperty('--tenant-color-primary-rgb', rgbPrimary);
  root.style.setProperty('--tenant-color-accent-rgb', rgbAccent);
}
